import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  LoginComponent,
  ManageUserComponent,
  ProfileComponent,
  UnauthorizedComponent,
} from 'tt-authentication-lib';
import { UserAuthGuard } from './authentication/guards/user-auth.guard';
import { HomeComponent } from './pages/components/home/home.component';
import { TtWebStoreModule, WebStoreComponent } from 'tt-web-store';
import {
  CollectionViewComponent,
  DeleteItemComponent,
  EditFormComponent,
  ExportCollectionComponent,
  ImportCollectionComponent,
  NewFormComponent,
  ViewCollectionItemComponent,
  FormDataViewComponent,
} from 'tt-collection-view-lib';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [UserAuthGuard],
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [UserAuthGuard],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [UserAuthGuard],
  },
  {
    path: 'user/manage',
    component: ManageUserComponent,
    canActivate: [UserAuthGuard],
  },
  {
    path: 'store',
    component: WebStoreComponent,
    data: { mode: 'admin' },
    loadChildren: () => TtWebStoreModule,
  },
  { path: 'forms/list', component: FormDataViewComponent },
  { path: 'collection/manage/:id', component: CollectionViewComponent },
  { path: 'collection/manage/:id/new', component: NewFormComponent },
  {
    path: 'collection/manage/:id/import',
    component: ImportCollectionComponent,
  },
  {
    path: 'collection/manage/:id/export',
    component: ExportCollectionComponent,
  },
  {
    path: 'collection/manage/:id/view/:itemId',
    component: ViewCollectionItemComponent,
  },
  { path: 'collection/manage/:id/edit/:itemId', component: EditFormComponent },
  {
    path: 'collection/manage/:id/delete/:itemId',
    component: DeleteItemComponent,
  },
  {
    path: '**',
    component: HomeComponent,
    canActivate: [UserAuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
